/**
 * viewportMenuStore — the Canvas→DOM bridge for the viewport right-click menu
 * (ENG-1050). Same module-singleton shape as waypointPickerStore/walkHereState.
 *
 * WHY A STORE AND NOT ONE COMPONENT. The menu needs the live camera to raycast
 * the ground, which means listening from INSIDE the R3F Canvas — but anything
 * returned from a component in that tree is reconciled by R3F, not react-dom, so
 * a `<div>`/`<style>` there crashes the app outright ("Style is not part of the
 * THREE namespace"). A react-dom `createPortal` does not help: the portal's
 * children are still created by the R3F reconciler. So the two halves are split
 * and this store is the seam:
 *
 *   ViewportContextMenu  (in Canvas)  raycast + openAt()
 *   ViewportMenu         (in the DOM) subscribes and renders
 */
let state = {
  open: null, // { x, y, items, ctx } | null
}
const listeners = new Set()
function emit() { for (const fn of listeners) fn() }

export const viewportMenuStore = {
  getState() { return state },
  subscribe(fn) { listeners.add(fn); return () => listeners.delete(fn) },
  /** Open at viewport coords with an already-resolved command list. */
  openAt({ x, y, items, ctx }) {
    state = { open: { x, y, items, ctx } }
    emit()
  },
  close() {
    if (!state.open) return // no-op: don't wake subscribers on every stray click
    state = { open: null }
    emit()
  },
}

if (typeof window !== 'undefined') window.__VIEWPORT_MENU__ = viewportMenuStore
